import React from "react";

export default function DashboardOverviewCards({
  usersAnalytics,
  proposalsAnalytics,
  onTodayUsersClick,
  onMonthUsersClick,
}) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-[1fr_1fr] xl:grid-cols-[60%_40%] gap-4 lg:gap-6 mb-4">
      <div className="w-full bg-white rounded-xl shadow-md border border-gray-100">
        <div className="flex flex-col gap-3 py-4 sm:py-6 px-3 sm:px-4 h-full">
          <div className="font-main font-semibold text-black text-left text-lg sm:text-xl">
            Overview
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 mt-2">
            <div
              className="flex flex-col gap-2 sm:gap-3 p-3 sm:p-4 rounded-xl bg-white border border-gray-200 cursor-pointer hover:shadow-lg transition-shadow"
              onClick={onTodayUsersClick}>
              <div className="font-main text-black font-[700] text-left text-sm sm:text-base">
                Today Users
              </div>
              <div className="text-2xl sm:text-3xl text-left font-main text-gray-900 font-[600]">
                {usersAnalytics?.today ?? 0}
              </div>
            </div>
            <div
              className="flex flex-col gap-2 sm:gap-3 p-3 sm:p-4 rounded-xl bg-white border border-gray-200 cursor-pointer hover:shadow-lg transition-shadow"
              onClick={onMonthUsersClick}>
              <div className="font-main text-black font-[700] text-left text-sm sm:text-base">
                Monthly Users
              </div>
              <div className="text-2xl sm:text-3xl text-left font-main text-gray-900 font-[600]">
                {usersAnalytics?.month ?? 0}
              </div>
            </div>
            <div className="flex flex-col gap-2 sm:gap-3 p-3 sm:p-4 rounded-xl bg-white border border-gray-200 sm:col-span-2 lg:col-span-1">
              <div className="font-main text-black font-[700] text-left text-sm sm:text-base">
                Total Users
              </div>
              <div className="text-2xl sm:text-3xl text-left font-main text-gray-900 font-[600]">
                {usersAnalytics?.total ?? 0}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full bg-white rounded-xl shadow-md border border-gray-100">
        <div className="flex flex-col gap-3 py-4 sm:py-6 px-3 sm:px-4">
          <div className="font-main font-semibold text-black text-left text-lg sm:text-xl">
            Proposals
          </div>
          <div className="text-center mt-2 px-0 sm:px-3 h-full">
            <div className="w-full flex flex-col gap-2 sm:gap-3 p-3 sm:p-4 rounded-xl bg-white border border-gray-200">
              <div className="font-main text-black font-[700] text-left text-sm sm:text-base">
                Total Proposals
              </div>
              <div className="text-2xl sm:text-3xl text-left font-main text-gray-900 font-[600]">
                {proposalsAnalytics?.total_proposals ?? 0}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
